import React, {
  Fragment,
  useState,
  useCallback,
  useMemo,
  useEffect,
} from "react";
import differenceBy from "lodash/differenceBy";
import { Trash2, Edit, Plus, Eye, Printer, Download } from "react-feather";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import { saveAs } from 'file-saver';
import { useNavigate } from "react-router-dom";
import * as XLSX from 'xlsx';
import { useTranslation } from 'react-i18next';

import DatePicker from 'react-datepicker';
import {

  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Badge,
  Modal, ModalBody, ModalFooter, ModalHeader, Label
} from "reactstrap";
import SingleSelect from "../../SingleSelect/SingleSelect";
import { Btn, H5 } from "../../../AbstractElements";
import axios from "axios";

const user_options = ["Name", "Province", "District", "UIDs", "Status", "Created Date"];

const FilterComponent = ({
  filterText,
  onFilter,
  onClear,
  userOption,
  setSelectedUserOption,
  t,
  startDate3,
  handleChange3,
}) => (
  <div style={{ display: "flex", flexDirection: "row" }}>
    <SingleSelect
      options={user_options}
      selectedOption={userOption}
      onChange={setSelectedUserOption}
    />
        {userOption === 'Status' ?
      <SingleSelect
        options={["Submitted", "Send For Edits", "Accepted", "Rejected"]}
        selectedOption={filterText}
        onChange={(e) => onFilter({ target: { value: e } })}
      />
      : userOption === 'Created Date'?
      <DatePicker className="form-control digits" showPopperArrow={false} selected={startDate3} showTimeSelect dateFormat="Pp" onChange={handleChange3} />
      :  <>
    <input
      className="form-control"
      placeholder={userOption === 'District'? t("Filter by District") : userOption === 'Name'? t("Filter by Name") : userOption === 'Province'? t("Filter by Province"): userOption === 'UIDs'? t("Filter by UIDs") : t("Filter by Status") }
      aria-label="Search Input"
      style={{ width: "250px", paddingLeft: "5px" }}
      name="phone"
      id="search"
      type="text"
      value={filterText}
      onChange={onFilter}
    />
    <Btn attrBtn={{ onClick: onClear }} type="button">
      X
    </Btn>
    </>
    }
  </div>
);


const DataTablesContain = () => {
  const token = localStorage?.getItem("token");
  const [data, setData] = useState();
  const [user_id, setUserId] = useState();
  const { t } = useTranslation();
  const [currentStart, setCurrentStart] = useState('');
  const [currentEnd, setCurrentEnd] = useState('');
  const pres = localStorage.getItem("pres");
  const [startDate, setstartDate] = useState(
    new Date()
  );
  const [startDate3, setstartDate3] = useState(
    new Date()
  );
  const handleChange = date => {
    setstartDate(date);
  };
  const [endDate, setEndDate] = useState(new Date());
  const handleChange2 = date => {
    setEndDate(date);
  };
  const handleChange3 = date => {
    setstartDate3(date);
    setFilterText(date.toISOString().split('T')[0]);
  };
  const [modal, setModal] = useState(false);
  const [userOption, setSelectedUserOption] = useState('Name')
  const toggle = (e) => {
    e.preventDefault()
    setModal(!modal)
  };
  const [filteredItems, setFilteredItems] = useState();
  useEffect(() => {
    handle_get_firms();
    handle_get_dates();
  }, []);


  const handle_get_firms = async () => {
    try {
      const response2 = await axios.get("https://api-portal.nada.org.np/api/proxies", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (response2?.data?.success) {
        setData(response2?.data?.data?.proxies);
        setFilteredItems(response2?.data?.data?.proxies);
      }
    } catch (error) {
      if (error.response) {
        console.error("Error response:", error.response);
        toast.error(error?.response?.data?.message || "An error occurred");
      } else if (error?.request) {
        console.error("Error request:", error?.request);
        toast.error("No response received from server");
      } else {
        console.error("Error message:", error?.message);
        toast.error(error?.message);
      }
    }
  };

  const handle_get_dates = async () => {
    try {
      const response2 = await axios.get("https://api-portal.nada.org.np/api/proxies/proxy/dates", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (response2?.data?.success) {
        setCurrentEnd(response2?.data?.data?.dates?.[0]?.end_date);
        setCurrentStart(response2?.data?.data?.dates?.[0]?.start_date);
        setstartDate(new Date(response2?.data?.data?.dates?.[0]?.start_date));
        setEndDate(new Date(response2?.data?.data?.dates?.[0]?.end_date));
      }
    } catch (error) {
      if (error.response) {
        console.error("Error response:", error.response);
        toast.error(error?.response?.data?.message || "An error occurred");
      } else if (error?.request) {
        console.error("Error request:", error?.request);
        toast.error("No response received from server");
      } else {
        console.error("Error message:", error?.message);
        toast.error(error?.message);
      }
    }
  };
  const navigate = useNavigate();
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleCleared, setToggleCleared] = useState(false);

  const contextActions = useMemo(() => {
    const handleDelete = () => {
      if (
        window.confirm(
          `Are you sure you want to delete:\r ${selectedRows.map(
            (r) => r.name
          )}?`
        )
      ) {
        setToggleCleared(!toggleCleared);
        setData(differenceBy(data, selectedRows, "name"));
        toast.success("Successfully Deleted !");
      }
    };

    return (
      <Btn attrBtn={{ color: "danger", onClick: handleDelete }} key="delete">
        Delete
      </Btn>
    );
  }, [data, selectedRows, toggleCleared]);

  const handleClick = (link, e) => {
    e.preventDefault();
    window.open(link, "_blank", "noopener,noreferrer");
  };

  function ComponentEdit({ row }) {
    return (
      <span style={{ display: "flex", flexDirection: "row", gap: 15, cursor: 'pointer' }}>
        <div
          onClick={() => {
            navigate("/proxy/edit", { state: { id: row?.id } });
          }}
        >
          <Edit />
        </div>
        {row?.status === 3?
          <>
            <div
          onClick={(e) => {
            handleClick(row?.proxy_doc, e);
          }}
        >
          <Eye />
        </div>
        <div
          onClick={(e) => {
            handleClick(row?.proxy_doc, e);
          }}
        >
          <Printer />
        </div>
        <div
          onClick={(e) => {
            handleClick(row?.proxy_doc, e);
          }}
        >
          <Download />
        </div>
          </>
          : null
        }
        {/*<div onClick={(e) => handleDelete(row?.id, e)}>
        <Trash2 color="#e52727" />
      </div>*/}
      </span>
    );
  }

  const handleAddNewClick = () => {
    navigate("/firm/add");
  };

  const renderStatusBadge = (status) => {
    switch (status) {
      case 1:
        return <Badge color="primary">Submitted</Badge>;
      case 2:
        return <Badge color="secondary">Send For Edits</Badge>;
      case 3:
        return <Badge color="success">Accepted</Badge>;
      case 4:
        return <Badge color="danger">Rejected</Badge>;
      default:
        return <Badge color="warning">Submitted</Badge>;
    }
  };

  const customStyles = {
    headCells: {
      style: {
        height: "80px",
        fontSize: "20px", // Change font size
        fontWeight: "bold", // Make it bold
        color: "#333", // Optional: Change text color
        backgroundColor: "#f5f5f5", // Optional: Change background color
      },
    },
  };

  const tableColumns = [
    {
      name: t("ID"),
      selector: (Row) => Row["id"],
      sortable: true,
      center: true,
    },
    {
      name: t("Name of Firm"),
      selector: (Row) => Row["name_of_organization"],
      sortable: true,
      center: true,
    },
    {
      name: t("Proxy UID"),
      selector: (Row) => Row["uid"],
      sortable: true,
      center: true,
    },
    {
      name: t("Created Date"),
      selector: (Row) => Row["date"],
      sortable: true,
      center: true,
    },
    {
      name: t("Status"),
      selector: (Row) => renderStatusBadge(Row["status"]),
      sortable: true,
      center: true,
    },
 { name: t("Actions"), cell: (row) => <ComponentEdit row={row} /> }
  ];

  const handleRowSelected = useCallback((state) => {
    setSelectedRows(state.selectedRows);
  }, []);

  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);

  const subHeaderComponentMemo = React.useMemo(() => {
    if (filterText === '') {
      setFilteredItems(data);
    } else {
      setFilteredItems(
        userOption === "Name"
          ? data?.filter((item) =>
              item?.name_of_organization
                ?.toLowerCase()
                ?.includes(filterText?.toLowerCase())
            )
          : userOption === "Province"
          ? data?.filter((item) =>
              item?.province?.toLowerCase()?.includes(filterText?.toLowerCase())
            )
          : userOption === "District"
          ? data?.filter((item) =>
              item?.district?.toLowerCase()?.includes(filterText?.toLowerCase())
            )
          : userOption === "UIDs"
          ? data?.filter((item) =>
            item?.uid?.toLowerCase()?.includes(filterText?.toLowerCase())
          )
          : userOption === "Created Date"
          ? data?.filter((item) => {
            const dbDate = new Date(item?.date);
            const selectedDate = new Date(startDate3);
            return (
                dbDate.getFullYear() === selectedDate.getFullYear() &&
                dbDate.getMonth() === selectedDate.getMonth() &&
                dbDate.getDate() === selectedDate.getDate()
            )})
          : data?.filter((item) =>
            String(item?.status === 1? 'Submitted' : item?.status === 2?  'Send For Edits' : item?.status === 3?  'Accepted' : item?.status === 4?  'Rejected' : 'Send For Edits')?.toLowerCase()?.includes(filterText?.toLowerCase())
            )
      );
    }



    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      <FilterComponent
        onFilter={(e) => setFilterText(e.target.value)}
        onClear={handleClear}
        t={t}
        userOption={userOption}
        setSelectedUserOption={setSelectedUserOption}
        filterText={filterText}
        startDate3={startDate3}
        handleChange3={handleChange3}
      />
    );
  }, [filterText, resetPaginationToggle, userOption, data, t, startDate]);



  const handle_user_update = async (e) => {
    e.preventDefault();
    try {
      const response2 = await axios.put(
        "https://api-portal.nada.org.np/api/proxies/proxy/dates",
        {
          start_date: startDate,
          end_date: endDate
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        },
      );
      if (response2?.data?.success) {
        toast.success(response2?.data?.message);
        setModal(!modal);
      }
    } catch (error) {
      if (error.response) {
        console.error("Error response:", error.response);
        toast.error(error.response.data.message || "An error occurred");
      } else if (error.request) {
        console.error("Error request:", error.request);
        toast.error("No response received from server");
      } else {
        console.error("Error message:", error.message);
        toast.error(error.message);
      }
    }
  };

  console.log('start date', startDate);

  const generateRandomFileName = () => {
    const timestamp = Date.now();
    const randomString = Math.random().toString(36).substring(2, 15);
    return `${timestamp}_${randomString}`;
  };


  const exportToExcel = async (e) => {
    e.preventDefault();

    // 1) your incoming filteredItems
    if (!filteredItems?.length) {
      return toast.error('No data to export');
    }

    // 2) pick only the accepted ones
    const filteredForAccepted = filteredItems.filter(item => item.status === 3);

    if (!filteredForAccepted?.length) {
      return toast.error('No accepted proxies to export');
    }
    // 3) fetch all firms and pick the accepted ones
    const resp = await axios.get(
      "https://api-portal.nada.org.np/api/firms",
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!resp.data.success) {
      return toast.error('Failed to fetch firms');
    }

    const filteredFirms = resp.data.data.firms.filter(f => f.status === 3);

    // 4) merge each accepted record with its matching firm
    const combined = filteredForAccepted.map(acc => {
      const firm = filteredFirms.find(f => f.id === acc.firm_id) || {};
      return {
        // from filteredFirms
        firm_name: firm.name_of_firm ?? '',
        pan_number: firm.pan_number ?? '',
        contact_person: firm.contact_person ?? '',
        contact_person_num: firm.contact_person_num ?? '',
        firm_position: firm.position ?? '',
        // from filteredForAccepted
        accepted_name: acc.name,
        accepted_position: acc.position,
        accepted_phone_number: acc.phone_number,
      };
    });

    // 5) build the worksheet + workbook
    const worksheet = XLSX.utils.json_to_sheet(combined);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Accepted');

    // 6) write & trigger download
    const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([wbout], { type: 'application/octet-stream' });
    const fileName = generateRandomFileName(); // your helper
    saveAs(blob, `${fileName}.xlsx`);
  };


  return (
    <Fragment>
      <Container fluid={true} className="data-tables">
        <Row>
          <Col sm="12">
            <Card>
              <CardHeader
                className="pb-0"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <H5>{t("Proxies")}</H5>
                {/*<Btn
                  attrBtn={{ color: "primary", onClick: handleAddNewClick }}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  Add New
                </Btn>*/}
                <div style={{ display: "flex", flexDirection: "row", gap: 10 }}>
                <Btn
                    attrBtn={{ color: "secondary", onClick: (e) => exportToExcel(e) }}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {t("export as csv")}
                  </Btn>
                  <Btn
                    attrBtn={{ color: "secondary", onClick: toggle }}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {t("Set Proxy Date")}
                  </Btn>
                </div>
              </CardHeader>
              <CardBody>
                {data && (
                  <DataTable
                    data={filteredItems}
                    columns={tableColumns}
                    striped={true}
                    center={true}
                    persistTableHead
                    subHeader
                    selectableRows
                    subHeaderComponent={subHeaderComponentMemo}
                    paginationResetDefaultPage={resetPaginationToggle}
                    onSelectedRowsChange={handleRowSelected}
                    clearSelectedRows={toggleCleared}
                    pagination
                    customStyles={customStyles}
                  />
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      <Modal isOpen={modal} toggle={toggle}
      //size={props.size}
      centered
      >
      <ModalHeader toggle={toggle}>
      {t("Set Proxy Date")}
      </ModalHeader>
      <ModalBody
        style={{ flexDirection: 'column', display: 'flex', gap: 10}}
      //className={props.bodyClass}
      >
        <div
          style={{ flexDirection: 'row', display: 'flex', gap: 20, alignItems: 'center'}}
        >
        <Label className="form-label">{t("Start Date & Time")}</Label>
        <DatePicker className="form-control digits" showPopperArrow={false} selected={startDate} showTimeSelect dateFormat="Pp" onChange={handleChange} />
        </div>
        <div
          style={{ flexDirection: 'row', display: 'flex', gap: 20, alignItems: 'center'}}
        >
        <Label className="form-label">{t("End Date & Time")}</Label>
        <DatePicker className="form-control digits" showPopperArrow={false} selected={endDate} showTimeSelect dateFormat="Pp" onChange={handleChange2} />
        </div>
      </ModalBody>
      <ModalFooter>
        <Btn attrBtn={{ color: 'secondary', onClick: toggle, height: 65 }} >{t("Close")}</Btn>
        <Btn attrBtn={{ color: 'primary', onClick: (e)=> handle_user_update(e), outerHeight: 65 }}>{t("Update")}</Btn>
      </ModalFooter>
    </Modal>
    </Fragment>
  );
};
export default DataTablesContain;
